import { BASE_URl } from '@/api/index'

interface ResponseData {
  result: string
  cid: number
  title: string
  fio: string
  address: string
  price: number
}

interface Contract {
  id: string
  title: string
  fullName: string
  address: string
  payment: number
}

export const getContract = async (houseId: string, flat: string) => {
  const formData = new FormData()
  formData.append('hid', houseId)
  formData.append('flat', flat)

  const res = await fetch(`${BASE_URl}/getContract.php`, {
    method: 'POST',
    body: formData,
  })

  const data = await res.json()

  if (!res.ok || data.result === 'error') {
    throw new Error(data.message || 'Ошибка при получении данных о договоре')
  }

  return transformContract(data)
}

const transformContract = (data: ResponseData): Contract => {
  return {
    id: data.cid.toString(),
    title: data.title,
    fullName: data.fio,
    address: data.address,
    payment: data.price,
  }
}
